import React, { FC } from 'react';
import { Order } from 'models/order';
import { Alert, Box, Button } from '@mui/material';
import DHDialog from 'components/shared/dh-dialog/dh-dialog.component';
import { useTranslation } from 'react-i18next';
import { useMutation } from '@apollo/client';
import { archiveOrderTemplate } from 'apollo/templates/order';
import { useDenthubErrorBoundary } from 'components/shared/denthub-error-boundary/denthub-error-boundary-context';

type ArchiveOrderDialogProps = {
    onUpdate?: (order: Order) => void;
    onClose: () => void;
    open: boolean;
    orderId: string;
};

const ArchiveOrderDialog: FC<ArchiveOrderDialogProps> = ({
    onUpdate,
    onClose,
    open,
    orderId,
}: ArchiveOrderDialogProps) => {
    const { t: translate } = useTranslation(['orders']);
    const { showBoundary } = useDenthubErrorBoundary();

    const [archiveOrder] = useMutation(archiveOrderTemplate, {
        onCompleted: ({ archiveOrder }) => {
            onClose();
            onUpdate?.(archiveOrder);
        },
        onError(error) {
            showBoundary(error);
        },
    });

    const handleArchiveOrder = async () => {
        await archiveOrder({
            variables: {
                orderId: orderId,
            },
        });
    };

    return (
        <DHDialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            title={translate('orders:ARCHIVE_THE_ORDER')}
            actions={
                <Button
                    sx={{ minWidth: 250 }}
                    variant="contained"
                    onClick={handleArchiveOrder}
                    data-test="archive-order-btn"
                >
                    {translate('orders:ARCHIVE_THE_ORDER')}
                </Button>
            }
        >
            <Box>
                <Box mb={2}>{translate('orders:ARE_YOU_SURE_THAT_YOU_WANT_TO_ARCHIVE_THE_ORDER')} ? </Box>
                <Alert severity="info" sx={{ whiteSpace: 'pre-wrap' }}>
                    <strong>
                        {translate('orders:THE_ORDER_WILL_BE_ARCHIVED_FOR_EVERYONE_IN_THE_SAME_ORGANIZATION')}
                    </strong>
                </Alert>
            </Box>
        </DHDialog>
    );
};
export default ArchiveOrderDialog;
